import { getVar } from "constant/less-vars";
import { PropTypeMediaEntry } from "fleet/prop-types";
import { SpotPreview } from "fleet/view/strategy-v2/spot-preview";
import PropTypes from "prop-types";
import React from "react";

const BORDER_WIDTH = parseInt(getVar("selected-adjacent-border-width"), 10);
const SIDEBAR_WIDTH = parseInt(getVar("ui-sidebar-width"), 10);

class ContentGroupPreviewBar extends React.PureComponent {
  static get propTypes() {
    return {
      mediaEntries: PropTypes.arrayOf(PropTypeMediaEntry),
      index: PropTypes.number,
      navigateTo: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      mediaEntries: [],
      index: 0,
      navigateTo: () => {},
    };
  }

  constructor(props) {
    super(props);

    this.ref = {
      container: null,
      panels: {},
    };

    this.state = {
      initialized: false,
    };

    this.renderContents = this.renderContents.bind(this);
    this._setContainerRef = this._setContainerRef.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { mediaEntries } = this.props;
    const meChanged = mediaEntries !== prevProps.mediaEntries;

    if (meChanged) {
      this.setState({ initialized: false });
      this.ref = {
        container: null,
        panels: {},
      };
    }
  }

  componentDidMount() {
    // After the component mounts we have references to panels.
    // Redraw once more to initialize the position of the panels.
    this.setState({ initialized: true });
  }

  componentDidUpdate() {
    // When component receives new mediaEntries we need to get the latest
    // refs (the old refs are stale).
    const { initialized } = this.state;

    if (!initialized) {
      this.setState({ initialized: true });
    }
  }

  _setContainerRef(elem) {
    this.ref.container = elem;
  }

  calcScrollPosition(panel = { offsetLeft: 0, clientWidth: 0 }, index) {
    const borderAdjust = index * BORDER_WIDTH;
    const sidebarMidpoint = SIDEBAR_WIDTH / 2;

    return (
      (panel.offsetLeft +
        panel.clientWidth / 2 -
        sidebarMidpoint +
        borderAdjust) *
      -1
    );
  }

  renderContents(mediaEntry, i) {
    const { index, navigateTo } = this.props;
    const { mimeType, numberOfSpots, type, url } = mediaEntry;
    const isActive = i === index ? " active" : "";

    return (
      <div
        key={i}
        className={"cg-preview clickable" + isActive}
        ref={(elem) => {
          this.ref.panels[i] = elem;
        }}
        onClick={() => {
          navigateTo(i);
        }}
      >
        <SpotPreview
          mimeType={mimeType}
          numberOfSpots={numberOfSpots}
          showControls={false}
          type={type}
          url={url}
        />
      </div>
    );
  }

  render() {
    const { mediaEntries, index } = this.props;
    const { panels } = this.ref;

    const x = this.calcScrollPosition(panels[index], index);
    const containerStyle = {
      transform: `translate(${x}px)`,
    };

    return (
      <div
        className="content-group-preview-bar col-margin-fix"
        style={containerStyle}
        ref={this._setContainerRef}
      >
        {mediaEntries.map(this.renderContents)}
      </div>
    );
  }
}

export { ContentGroupPreviewBar };
